import { CreditCard } from '@mui/icons-material'
import style from './sass/custom/inputs.module.scss'
import CreditCardInput from 'react-credit-card-input';
import { useState } from 'react';

const TestNestPay = () => {
  const [cardNumber, setCardNumber] = useState('')
  const [cardExpiry, setCardExpiry] = useState('')
  const [cardCvc, setCardCvc] = useState('')

  return (
    <div>
      <CreditCardInput 
        cardNumberInputProps={{ value: cardNumber, onChange: (e) => setCardNumber(e.target.value) }}
        cardExpiryInputProps={{ value: cardExpiry, onChange: (e) => setCardExpiry(e.target.value) }}
        cardCVCInputProps={{ value: cardCvc, onChange: (e) => setCardCvc(e.target.value) }}
        
        fieldClassName="input"
      />
      <button onClick={() => {
        console.log(cardNumber)
        console.log(cardExpiry.split('/').map((item) => item.trim()))
        console.log(cardCvc)
      }}>ladksjf</button>
        <form className='flex flex-col gap-1' action="https://istest.asseco-see.com.tr/fim/est3Dgate" method="POST" >
            <div>
              <span>clientid</span>
              <input className={style.input} type="hidden" name="clientid" value="700321123123" />
              
              </div>
            <div>
              <span>pan</span>
              <input className={style.input} type="" name="pan" value="4284624140544525" />
              
              </div>
            <div>
              <span>Ecom_Payment_Card_ExpDate_Year</span>
              <input className={style.input} type="" name="Ecom_Payment_Card_ExpDate_Year" value="12" />
              
              </div>
            <div>
              <span>Ecom_Payment_Card_ExpDate_Month</span>
              <input className={style.input} type="" name="Ecom_Payment_Card_ExpDate_Month" value="12" />
              
              </div>
            <div>
              <span>cardType</span>
              <input className={style.input} type="" name="cardType" value="1" />
              
              </div>
            <div>
              <span>cv2</span>
              <input className={style.input} type="" name="cv2" value="000" />
              
              </div>
            <div>
              <span>amount</span>
              <input className={style.input} type="" name="amount" value="27" />
              
              </div>
            <div>
              <span>oid</span>
              <input className={style.input} type="" name="oid" value="local-10-8da94" />
              
              </div>
            <div>
              <span>okUrl</span>
              <input className={style.input} type="" name="okUrl" value="http://localhost/api/payment/nestpay/shipment-bills/10" />
              
              </div>
            <div>
              <span>failUrl</span>
              <input className={style.input} type="" name="failUrl" value="http://localhost/api/payment/nestpay/shipment-bills/failed" />
              
              </div>
            <div>
              <span>rnd</span>
              <input className={style.input} type="" name="rnd" value="4196ee6b-d19a-4ac4-b724-49af6c7f0914" />
              
              </div>
            <div>
              <span>currency</span>
              <input className={style.input} type="" name="currency" value="949" />
              
              </div>
            <div>
              <span>storetype</span>
              <input className={style.input} type="" name="storetype" value="3d" />
              
              </div>
            <div>
              <span>lang</span>
              <input className={style.input} type="" name="lang" value="tr" />
              
              </div>
            <div>
              <span>hash</span>
              <input className={style.input} type="" name="hash" value="tLc10fNxCxI3oLLitWpU/NYaLaM=" />
              
              </div>
            <button type="submit">SUBMIT</button>
        </form>
    </div>
  )
}

export default TestNestPay